import React from 'react';
import { Upload, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { UploadProps, UploadFile } from 'antd/lib/upload/interface';
import { FormattedMessage } from 'react-intl';
import { uploadPicture } from '../../service/support';
import styles from './index.module.less';

interface PicturesWallProps extends Omit<UploadProps, 'onChange'> {
  requestCategoryId: string,
  value?: string[],
  onChange?: (value: string[]) => void
}

const PicturesWall: React.FC<PicturesWallProps> = ({
  requestCategoryId, value, onChange, ...rest
}) => {
  const [fileList, setFileList] = React.useState<UploadFile<string>[]>([]);

  React.useEffect(
    () => {
      if (!value) {
        setFileList([]);
      }
    },
    [value],
  );

  return (
    <>
      <Typography.Text
        type="secondary"
        style={{
          display: 'block',
          position: 'relative',
          top: -10,
          marginBottom: 2,
        }}
      >
        <FormattedMessage id="Contact.Notice.Image" />
      </Typography.Text>

      <Upload
        {...rest}
        className={styles.upload}
        fileList={fileList}
        onChange={({ fileList }) => {
          setFileList([...fileList]);
          const files: string[] = fileList
            .filter(({ status }) => status === 'done')
            .map(({ response }) => response.temporaryAttachmentId);
          onChange && onChange(files);
        }}
        accept="image/bmp,image/png,image/jpeg"
        customRequest={async ({
          file, onProgress, onError, onSuccess,
        }) => {
          try {
            const temporaryAttachmentId = await uploadPicture({
              requestCategoryId,
              picture: file,
            }, {
              onUploadProgress: (event) => {
                onProgress({ percent: event.loaded / event.total * 100 }, file);
              },
            });
            onSuccess({ temporaryAttachmentId }, file);
          } catch (err) {
            onError(err);
          }
        }}
        listType="picture-card"
      >
        {fileList.length >= 8 ? null : <PlusOutlined />}
      </Upload>
    </>
  );
};

export default PicturesWall;
